import { Check, CheckCircle, Delete } from "@mui/icons-material"
import { Box, CircularProgress, IconButton, Stack, Tooltip } from "@mui/material"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { CustomDataGrid } from "components/common-styles"
import PaperComponent from "components/common/paper-component"
import { observer } from "mobx-react-lite"
import { useState } from "react"
import { rootStore } from "stores/root-store"
import RefreshIcon from "@mui/icons-material/Refresh"

const CustomSettingsDialog = ({ moduleName, open, onClose, onDelete, onSelect }) => {
  const data = rootStore.userConfigs ? rootStore.userConfigs[moduleName] : null
  const columns = [
    {
      field: "Config_Name",
      headerName: "Name",
      minWidth: 250,
      flex: 1,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      renderCell: params => (
        <Box sx={{ display: "flex", justifyContent: "center", flex: 1 }}>
          {isSubmitting ? (
            <CircularProgress />
          ) : params.row.Id == rootStore.selectedUserConfigId ? (
            <Stack direction={"row"} style={{ alignItems: "center" }}>
              <Tooltip placement="top" title="Refresh">
                <IconButton id="btnRefreshFilter" aria-label="actions" onClick={() => onSelectClicked(params.row.Id)}>
                  <RefreshIcon />
                </IconButton>
              </Tooltip>
              <Tooltip placement="top" title="Selected">
                <CheckCircle />
              </Tooltip>
            </Stack>
          ) : (
            <Stack direction={"row"}>
              <Tooltip placement="top" title="Select">
                <IconButton id="btnSelectFilter" aria-label="actions" onClick={() => onSelectClicked(params.row.Id)}>
                  <Check />
                </IconButton>
              </Tooltip>
              <Tooltip placement="top" title="Delete">
                <IconButton id="btnDeleteFilter" aria-label="actions" onClick={() => onDeleteClicked(params.row.Id)}>
                  <Delete />
                </IconButton>
              </Tooltip>
            </Stack>
          )}
        </Box>
      ),
    },
  ]

  const [isSubmitting, setIsSubmitting] = useState("")

  const onSelectClicked = id => {
    onSelect(id)
    onClose()
  }

  const onDeleteClicked = async id => {
    setIsSubmitting(true)
    await onDelete(id)
    setIsSubmitting(false)
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        Custom settings
      </DialogTitle>
      <DialogContent dividers style={{ display: "flex" }}>
        <CustomDataGrid
          style={{ width: 600, height: 400 }}
          getRowId={row => row.Id}
          rows={data || []}
          columns={columns}
          disableColumnResize={true}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 15,
              },
            },
          }}
          pageSizeOptions={[15, 20, 50]}
          disableRowSelectionOnClick
        />
      </DialogContent>
    </Dialog>
  )
}

export default observer(CustomSettingsDialog)
